import React from 'react';
import { FormattedMessage, FormattedDate, useIntl } from 'react-intl';
import classnames from 'classnames';
import dayjs from 'dayjs';
import { ColumnTree } from '../hooks/useTable/defineColumns';
import { unitsOfMeasure } from '~/utils';
import { getDeliveryFrequencyLabel } from '~/utils/deliveryFrequency';
import * as R from 'ramda';

export const EtdToColumn = ColumnTree.defineNode(
  'etd-to',
  ({ sortDirection, sortColumn, setSort, productById }) => {
    const { formatMessage } = useIntl();

    return {
      title: (
        <div>
          <a
            href="#etd-to"
            className={classnames('icon-sort', 'sortem', {
              [sortDirection]: sortColumn === 'etd-to',
            })}
            onClick={() => setSort('etd-to')}
          >
            <FormattedMessage
              id="marketplace-table-heading-etdto"
              description="Table heading, ETD to time"
              defaultMessage="ETD To"
            />
          </a>
        </div>
      ),
      key: 'etd-to',
      className: 'col-etd-to',
      render: (text, record) => {
        const { totaldeliveries, deliveryfrequency, quarteretd } = record;

        if (quarteretd)
          return {
            children: null,
            props: { colSpan: 0 },
          };

        if (deliveryfrequency) {
          const u: string = R.pathOr('', ['volume', 'unit'], record);
          const product = productById(record.product.id);
          const unit: string = product
            ? R.pathOr('', ['loadingunit', 'desc'], product)
            : R.pathOr(u, [u], unitsOfMeasure);

          return (
            <div className="td-content">
              <div className="delivery-volume nowrap">
                <strong className="all-black">{totaldeliveries}</strong>
                <span className="times-rotate">+</span>
                <strong className="all-black">{record.volume.delivery}</strong>
                <span className="unit">{unit}</span>
              </div>
              <div>
                <span
                  className={classnames(
                    'icon-clock',
                    'periodic-delivery',
                    deliveryfrequency
                  )}
                >
                  {getDeliveryFrequencyLabel(formatMessage, deliveryfrequency)}
                </span>
              </div>
            </div>
          );
        }

        return (
          <div className="td-content">
            <span className="tiny-label">
              <FormattedMessage
                id="marketplace-table-cell-etdto"
                defaultMessage="ETD to"
              />
            </span>
            <span className="nowrap">
              <FormattedDate
                value={dayjs(record.etd.to).toDate()}
                day="numeric"
                month="short"
                year="numeric"
              />
            </span>
          </div>
        );
      },
    };
  }
);
